import { BasicRequest } from "./basicRequest";

export class UndeleteFileDefinitionRequest extends BasicRequest{
    public fileDefinitionId!: number;
}